import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import ArrowBackIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIcon from '@material-ui/icons/ArrowForwardIos';
import Fade from '@material-ui/core/Fade';
import Slide from '@material-ui/core/Slide';
import parse from 'html-react-parser';

import Container from '../../containers/Container';
import Button from '../../components/Button';
import Hexa from '../../components/Hexa';
import PdfLoader from '../../utils/PdfLoader';
import styles from './styles';

const HEXA_COLOR = ['#FCC243', '#F29FC5', '#00A3B4', '#A51367', '#EF7D00'];

class HomeSlider extends React.Component {
  constructor(props) {
    super(props);
    this.stepBack = this.stepBack.bind(this);
    this.stepNext = this.stepNext.bind(this);
    this.state = { step: 0 };
  }

  stepBack() {
    const { list } = this.props.data.home.slider;
    this.setState(prev => ({ step: prev.step - 1 < 0 ? list.length - 1 : prev.step - 1 }));
  }

  stepNext() {
    const { list } = this.props.data.home.slider;
    this.setState(prev => ({ step: prev.step + 1 >= list.length ? 0 : prev.step + 1 }));
  }

  renderHexaRight(idx) {
    const { classes } = this.props;
    const { list } = this.props.data.home.slider;
    const hexaList = [];
    for (let i = list.length - 1; i > idx; i--) {
      hexaList.push(
        <Hexa
          key={i}
          className={classes.greenHexaRight}
          style={{ zIndex: i + 1 }}
          width={60}
          height={64}
          fill="#19926E"
          stroke="#3FA889"
        />,
      );
    }
    return <div className={classes.hexaRightContainer}>{hexaList}</div>;
  }

  renderHexaLeft(idx) {
    const { classes } = this.props;
    const hexaList = [];
    for (let i = 0; i < idx; i++) {
      hexaList.push(
        <Hexa
          key={i}
          className={classes.greenHexaLeft}
          style={{ zIndex: i + 1 }}
          width={60}
          height={64}
          fill="#19926E"
          stroke="#3FA889"
        />,
      );
    }
    return (
      <>
        {hexaList}
        <Hexa
          className={classes.mainHexa}
          width={60}
          height={64}
          text={idx + 1}
          fill={HEXA_COLOR[idx % HEXA_COLOR.length]}
          stroke="#fff"
          textColor="#fff"
        />
      </>
    );
  }

  render() {
    const { classes, data } = this.props;
    const { slider: block } = data.home;
    const { step } = this.state;
    return (
      <Container className={classes.container} id="home-slider">
        <Typography variant="h3" className={classes.title}>
          {parse(block.title)}
        </Typography>
        <div className={classes.titleSep}></div>
        <Button className={classes.buttonPdf} color="green2" onClick={PdfLoader(block.pdf)}>
          {parse(block.button)}
        </Button>
        <div className={classes.sliderContainer}>
          <div className={classes.sliderNav}>
            <IconButton className={classes.arrowBack} color="inherit" onClick={this.stepBack}>
              <ArrowBackIcon />
            </IconButton>
            {block.list.map((item, idx) => (
              <Fade key={idx} in={idx === step}>
                <div className={`${classes.sliderTitle} ${idx !== step ? classes.sliderTitleDisable : ''}`}>
                  {this.renderHexaLeft(idx)}
                  {this.renderHexaRight(idx)}
                  <Typography className={classes.sliderTitleText} variant="h2">
                    {parse(item.title)}
                  </Typography>
                </div>
              </Fade>
            ))}
            <IconButton className={classes.arrowForward} color="inherit" onClick={this.stepNext}>
              <ArrowForwardIcon />
            </IconButton>
          </div>
          <div className={classes.sliderContent}>
            {block.list.map((item, idx) => (
              <Slide direction="left" key={idx} in={idx === step}>
                <Typography
                  className={`${classes.sliderContentText} ${idx !== step ? classes.sliderContentTextDisable : ''}`}
                >
                  {parse(item.p)}
                </Typography>
              </Slide>
            ))}
          </div>
        </div>
      </Container>
    );
  }
}

HomeSlider.propTypes = {
  data: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(HomeSlider);
